var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8 64c1.974 0 3.9-7.054 5.761-7.43 13.146-2.647 23.039-14.176 23.039-28C57.6 12.793 44.705 0 28.8 0 12.895 0 0 12.792 0 28.57c0 13.82 9.888 25.345 23.027 27.998C24.891 56.945 26.821 64 28.8 64z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 64c1.974 0 3.9-7.054 5.761-7.43 13.146-2.647 23.039-14.176 23.039-28C57.6 12.793 44.705 0 28.8 0 12.895 0 0 12.792 0 28.57c0 13.82 9.888 25.345 23.027 27.998C24.891 56.945 26.821 64 28.8 64z",
    fill: "#2D5781"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    cx: 28.8,
    cy: 28.571,
    rx: 10.368,
    ry: 10.286
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/mapPin.917952c8ff3a595fc180bf24d45329ed.svg";
export { ForwardRef as ReactComponent };